//Tailwind
import { useEffect, useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";
import Register from "../features/auth/Register";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "../features/auth/authSlice";
import Kartice from "../features/pretplata/Kartice";

const Public = () => {
  const [blog, setblog] = useState();
  const [openLogin, setOpenLogin] = useState(true);
  const location = useLocation();

  const navigate = useNavigate();
  const vidiBlog = () => navigate("/blogsPublic");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   console.log(window.location.href); // Provera kompletnog URL-a
  // }, []);

  //Google
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const accessToken = urlParams.get("accessToken");

  //   console.log("accessToken", accessToken);

  //   if (accessToken) {
  //     document.cookie = `accessToken=${accessToken}; path=/;`;
  //     dispatch(setCredentials({ accessToken }));

  //     window.history.replaceState({}, document.title, "/dash");
  //   } else {
  //     console.error("Access token nije pronađen!");
  //   }
  // }, []);

  const faqs = [
    {
      id: 1,
      question: "Kako se registrovati na NutriTrans platformu?",
      answer: [
        'Kliknite na dugme "Registracija" u gornjem desnom uglu početne stranice.',
        "Unesite svoje osnovne informacije: email adresu i kreirajte lozinku.",
        "Potvrdite svoju email adresu klikom na link koji ćemo vam poslati.",
        "Nakon potvrde, prijavite se i započnite s korištenjem NutriTransa.",
      ],
    },
    {
      id: 2,
      question: "Da li je NutriTrans besplatan za korištenje?",
      answer: `NutriTrans nudi osnovnu verziju koja je potpuno besplatna i omogućava vam
              osnovno praćenje unosa hrane i aktivnosti. Također nudimo Premium pretplatu koja uključuje
              napredne funkcije kao što su personalizirani planovi ishrane, detaljne analize i pristup stručnim
              savjetima.`,
    },
    {
      id: 3,
      question: "Mogu li prilagoditi svoj nutritivni plan?",
      answer: [
        "Postavite svoje ciljeve (gubitak težine, povećanje mišićne mase, održavanje težine).",
        "Unesite svoje prehrambene preferencije i eventualne alergije.",
        "Naša platforma će generirati plan ishrane prilagođen vašim potrebama.",
      ],
    },
    {
      id: 4,
      question: "Kako mogu otkazati svoju pretplatu?",
      answer: [
        'Prijavite se na svoj račun i idite na "Pretplate".',
        'Odaberite opciju "Otkazati pretplatu"',
        "Slijedite upute za potvrdu otkazivanja.",
        "Napomena: Nakon otkazivanja, i dalje ćete imati pristup Premium funkcijama do kraja plaćenog perioda.",
      ],
    },
    {
      id: 5,
      question: "Da li su moji podaci sigurni?",
      answer: [
        "Koristimo napredne sigurnosne mere za zaštitu vaših podataka.",
        "Vaši podaci su enkriptirani tokom prijenosa i skladištenja.",
        "Ne delimo vaše lične informacije s trećim stranama bez vašeg pristanka.",
        "Više detalja pronađite u našoj Politici privatnosti.",
      ],
    },
    // Dodajte više pitanja i odgovora po potrebi
  ];

  //Za register modal
  const [showModalRegister, setShowModalRegister] = useState(false);
  const closeModalRegister = () => setShowModalRegister(false);
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openModalRegister = () => {
    // setMobileMenuOpen(false);
    setShowModalRegister(true);
  };

  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      closeModalRegister();
    }
  };

  const getRecentBlog = async () => {
    try {
      const baseUrl = `${process.env.REACT_APP_API_URL}`;

      const headers = new Headers();
      // if (token) {
      //   headers.set("Authorization", `Bearer ${token}`);
      // }
      headers.set("Content-Type", "application/json");

      const response = await fetch(`${baseUrl}/blogNew`, {
        method: "GET",
        headers: headers,
        // credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log('Data successfully saved:', result);
      setblog(result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  useEffect(() => {
    getRecentBlog();
  }, []);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const readableDate = date.toLocaleDateString("sr-RS", {
      year: "numeric", // godina
      month: "numeric", // mesec
      day: "numeric", // dan
    });

    return readableDate;
  }

  //Za blog desktop - work here
  const scrollToMiddle = () => {
    const middleOffset = window.innerHeight * 2.1;

    window.scrollTo({
      top: middleOffset,
      behavior: "smooth",
    });
  };

  // //Za blog mobile - OK
  const scrollToMiddleMobile = () => {
    const middleOffset = window.innerHeight * 4.1;

    window.scrollTo({
      top: middleOffset,
      behavior: "smooth",
    });
  };

  //Za pricu desktop - OK
  // const scrollToPrica = () => {
  //   const middleOffset = window.innerHeight * 0.7;

  //   window.scrollTo({
  //     top: middleOffset,
  //     behavior: "smooth",
  //   });
  // };

  // const scrollToPrica = () => {
  //   navigate("/"); // Ovde možeš promeniti putanju ako je potrebno

  //   setTimeout(() => {
  //     const scrollAmount = 200;

  //     window.scrollTo({
  //       top: window.innerHeight * 0.7,
  //       behavior: "smooth",
  //     });
  //   }, 1000);
  // };

  // //Za pricu movile - OK
  // const scrollToPricaMobile = () => {
  //   const middleOffset = window.innerHeight * 0.8;

  //   window.scrollTo({
  //     top: middleOffset,
  //     behavior: "smooth",
  //   });
  // };

  // //Za pomoc desktop
  // const scrollToPomoc = () => {
  //   const middleOffset = window.innerHeight * 6.0;

  //   window.scrollTo({
  //     top: middleOffset,
  //     behavior: "smooth",
  //   });
  // };

  // //Za pomoc mobile - OK
  // const scrollToPomocMobile = () => {
  //   const middleOffset = window.innerHeight * 4.9;

  //   window.scrollTo({
  //     top: middleOffset,
  //     behavior: "smooth",
  //   });
  // };

  return (
    <>
      <LandingHeader
        onScrollToMiddle={scrollToMiddle}
        onScrollToMiddleMobile={scrollToMiddleMobile}
        // onScrollPrica={scrollToPrica}
        // onScrollPricaMobile={scrollToPricaMobile}
        // onScrollToPomoc={scrollToPomoc}
        // onScrollToPomocMobile={scrollToPomocMobile}
      />

      {/* LANDING PAGE CONTENT - SAMO NA LANDINGU STA SE PRIKAZUJE */}
      <div className="flex items-center justify-center h-screen bg-cover bg-center pozadina">
        <div className="bg-opacity-90 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-sans font-bold text-black mb-7">
            <span className="block text-4xl sm:text-5xl md:text-6xl font-bold">
              Postani svoj
              {/* Poruci svoj plan */}
            </span>
            {/* <a href="#prica">Idite na priču</a> */}
            <span className="block text-4xl sm:text-5xl md:text-6xl font-bold">
              nutricionista
            </span>
          </h1>

          <button
            onClick={openModalRegister}
            className="px-6 py-2 text-black rounded-md hover:bg-green-600 font-bold"
            style={{ backgroundColor: "#66BB6A" }}
          >
            Poruči svoj plan
          </button>

          <div className="flex items-center justify-center mt-4">
            <img
              src={`${process.env.PUBLIC_URL}/img/L2.png`}
              alt="Logo"
              className="w-[600px] h-auto object-contain mt-5"
            />
          </div>

          {/* <br /> */}
          {/* <Kartice /> */}
        </div>
      </div>
      <div id="prica" />
      <div
        className="w-full overflow-x-hidden"
        // style={{ backgroundColor: "#0000FF" }}
      >
        <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

        <div className="bg-white ">
          <div className="text-center bg-white mt-8">
            <div className="flex items-center w-full max-w-full">
              <div className="flex-1 h-[2px] bg-black">
                {/* <span className="absolute -right-1 top-1/2 -translate-y-1/2 w-[8px] h-[8px] bg-green-600 rounded-full"></span> */}
              </div>

              <span className="mx-6 text-3xl font-extrabold text-black">
                Nutri Trans
              </span>

              <div className="flex-1 h-[2px] bg-black">
                {/* <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-[8px] h-[8px] bg-green-600 rounded-full"></span> */}
              </div>
            </div>

            <p className="px-4 text-lg font-medium text-black mt-8">
              NutriTrans je vaš praktičan saveznik za brzo i jednostavno
              postizanje ciljeva u ishrani i zdravlju, oslonjen na moć savremene
              AI tehnologije. Razumemo vaše potrebe i pomažemo vam da rešite
              svakodnevne izazove – od odabira prave hrane do smanjenja stresa i
              pronalaženja unutrašnjeg mira. Povezujući telo, um i duh u skladnu
              celinu, NutriTrans koristi veštačku inteligenciju kako bi vam
              pružio personalizovane savete i prilagođena rešenja. Svaka promena
              postaje jednostavna i ostvariva, dok vas pratimo na svakom koraku
              ka zdravijem i ispunjenijem životu.
            </p>

            <ul
              role="list"
              className="bg-white max-w-2xl mx-auto mt-8 p-4 sm:p-6 space-y-8"
            >
              {[
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture1.jpg`,
                  text: "Potpuno personalizovani planovi ishrane Svaki plan se kreira na osnovu unetih podataka korisnika, uključujući težinu, visinu, ciljeve, preferencije i zdravstvene parametre, garantujući rešenja koja odgovaraju individualnim potrebama.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture2.jpg`,
                  text: "Podrška veštačke inteligencije (AI) NutriTrans koristi napredne AI algoritme kako bi analizirao podatke i ponudio najsavremenije preporuke za zdravlje, mršavljenje ili održavanje forme, sa garantovanom tačnošću i efikasnošću.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture3.jpg`,
                  text: "Jednostavnost i pristupačnost Dizajniran za korisnike svih nivoa tehničke pismenosti, NutriTrans pruža intuitivan interfejs, brze rezultate i jednostavne korake za korišćenje – bez stresa ili konfuzije.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture4.jpg`,
                  text: "Širok fokus na zdravlje i holistički pristup Aplikacija ne samo da pomaže u mršavljenju, već podržava celokupno zdravlje kroz savete za ishranu, fizičku aktivnost, san, i mentalnu ravnotežu, osiguravajući trajne promene u životnom stilu.",
                },
                {
                  img: `${process.env.PUBLIC_URL}/img/mainPicture5.jpg`,
                  text: "Transparentnost i merenje rezultata Korisnici dobijaju detaljne izveštaje o svom napretku sa grafikonima, statistikom i analizama, čime se jasno prikazuje kako se ostvaruju njihovi ciljevi kroz vreme.",
                },
              ].map((item, index) => (
                <li
                  key={index}
                  className="flex flex-col items-center gap-4 sm:flex-row sm:items-start sm:justify-start"
                >
                  <img
                    src={item.img}
                    className="flex justify-center sm:justify-start max-w-[150px] w-full"
                    alt={`Image ${index + 1}`}
                  />
                  <p className="text-gray-700 font-medium text-left">
                    {item.text}
                  </p>
                </li>
              ))}
            </ul>
            <div id="blog" />
          </div>

          <div className="flex items-center w-full max-w-full">
            <div className="flex-1 h-[2px] bg-black">
              {/* <span className="absolute -right-1 top-1/2 -translate-y-1/2 w-[8px] h-[8px] bg-green-600 rounded-full"></span> */}
            </div>

            <span className="mx-6 text-3xl font-extrabold text-black">
              Blog
            </span>

            <div className="flex-1 h-[2px] bg-black">
              {/* <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-[8px] h-[8px] bg-green-600 rounded-full"></span> */}
            </div>
          </div>

          <div className="flex flex-col md:flex-row mt-4 gap-2">
            <div className="flex-1 px-4">
              {/* <h3 className="text-xl font-bold">
                Uz NutriTrans, niste same na putu ka zdravlju i blagostanju!!
              </h3>
              <p className="mt-2 text-gray-700">
                Nutritrans je vise od aplikacije za ishranu, ona je vaš
                saosećajni saputnik koji razume jedinstvene potrebe vašeg tela,
                uma i duha. Kroz inovativnu snagu veštačke inteligencije,
                personalizujemo vaše iskustvo kako bismo vam pomogli da
                uravnotežite ishranu, smanjite stres i pronađete unutrašnji mir.
                Vaša transformacija počinje iznutra, a NutriTrans je tu da vas s
                ljubavlju podrži na svakom koraku ka zdravijem i ispunjenijem
                životu.
              </p> */}

              {/* Ovde */}
              {blog && (
                <>
                  <div
                    className="mt-4 bg-white rounded-lg shadow-md overflow-hidden"
                    key={blog.id}
                  >
                    <div className="block">
                      <img
                        src={blog.slika}
                        alt="Placeholder Image"
                        className="w-full h-48 object-cover object-center md:object-top"
                      />
                      <div className="p-4">
                        <div className="flex items-center justify-between">
                          <h2 className="text-xl font-semibold text-gray-900">
                            {blog.title}
                          </h2>
                          <div className="flex flex-wrap space-x-2">
                            {Array.isArray(blog.tags) ? (
                              blog.tags.map((tag, index) => (
                                <span
                                  key={index}
                                  className="inline-block px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
                                >
                                  {tag}
                                </span>
                              ))
                            ) : (
                              <span className="text-red-600">
                                Tagovi nisu u pravilnom formatu.
                              </span>
                            )}
                          </div>
                        </div>
                        <p className="text-sm text-gray-600 mt-2">
                          Autor: {blog.author}
                        </p>
                        <p className="text-sm text-gray-600">
                          Datum: {formatDateToReadable(blog.date)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <button
                    className="my-4 text-black px-4 py-2 rounded font-bold"
                    style={{ backgroundColor: "#66BB6A" }}
                    onClick={vidiBlog}
                  >
                    Pogledaj sve blogove
                  </button>
                </>
              )}
            </div>

            <div className="flex-1 p-4">
              <img
                src={`${process.env.PUBLIC_URL}/img/landingImage.jpg`}
                alt="Descriptive Alt Text"
                className="w-full h-100 rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

      <div className="flex flex-col md:flex-row items-center h-auto gap-4 p-4">
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <p className="italic">
            "Neka hrana bude tvoj lek, a lek tvoja hrana."
          </p>
          <p>Hipokrat</p>
        </div>
        <div className="hidden md:flex items-center relative">
          <div
            className="absolute w-2 h-2 rounded-full top-[-4px] left-[5px]"
            style={{ backgroundColor: "#66BB6A" }}
          />
          <div className="w-0.5 h-24 bg-black mx-2" />
          <div
            className="absolute w-2 h-2 rounded-full bottom-[-4px] left-[5px]"
            style={{ backgroundColor: "#66BB6A" }}
          />
        </div>
        <div id="pomoc" /> {/* Moram ovde zbog kadra pregleda */}
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <p className="italic">
            "Kvalitet tvoje ishrane određuje kvalitet tvog života."
          </p>
          <p>Dr. Joel Fuhrman</p>
        </div>
      </div>

      <div className="w-full h-3" style={{ backgroundColor: "#66BB6A" }} />

      {/* <div className="mx-auto max-w-full px-6 py-12 sm:py-16 lg:px-8 lg:py-10">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl mb-6">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6">
          {faqs.map((faq) => (
            <>
              <div
                key={faq.id}
                className="flex items-start justify-between pt-4"
              >
              
                <div className="w-full sm:w-1/2">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </h3>
                </div>

                <div className="hidden sm:block sm:w-[2px] sm:bg-green-500 sm:h-full"></div>
        
                <div className="w-full sm:w-1/2 pl-6">
                  <ol className="list-decimal list-inside text-gray-600">
                    {faq.answer.map((item, index) => (
                      <li key={index} className="text-base leading-7">
                        {item}
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
              <div
                className="w-full h-1"
                style={{ backgroundColor: "#66BB6A" }}
              />
            </>
          ))}
        </div>
      </div> */}

      {/* <div className="mx-auto max-w-full px-6 py-12 sm:py-16 lg:px-8 lg:py-10">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl mb-6">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6">
          {faqs.map((faq) => (
            <>
              <div
                key={faq.id}
                className="flex items-start justify-between pt-4"
              >
                <div className="w-full sm:w-1/2">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </h3>
                </div>

                <div className="hidden sm:block sm:w-[2px] sm:bg-green-500 sm:h-full"></div>

                <div className="w-full sm:w-1/2 pl-6">
                  {faq.id === 2 ? (
                    <p className="text-base leading-7 text-gray-600">
                      {faq.answer}
                    </p>
                  ) : (
                    <ol className="list-decimal list-inside text-gray-600">
                      {faq.answer.map((item, index) => (
                        <li key={index} className="text-base leading-7">
                          {item}
                        </li>
                      ))}
                    </ol>
                  )}
                </div>
              </div>
              <div
                className="w-full h-1"
                style={{ backgroundColor: "#66BB6A" }}
              />
            </>
          ))}
        </div>
      </div> */}

      <div className="mx-auto max-w-full px-6 py-12 sm:py-16 lg:px-8 lg:py-10">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl mb-6">
          Najčešće postavljena pitanja
        </h2>
        <div className="space-y-6">
          {faqs.map((faq) => (
            <div key={faq.id}>
              <div className="flex flex-col sm:flex-row items-start justify-between pt-4">
                <div className="w-full sm:w-1/2">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </h3>
                </div>

                <div className="hidden sm:block sm:w-[2px] sm:bg-green-500 sm:h-full"></div>

                <div className="w-full sm:w-1/2 pl-0 sm:pl-6 mt-4 sm:mt-0">
                  {faq.id === 2 ? (
                    <p className="text-base leading-7 text-gray-600">
                      {faq.answer}
                    </p>
                  ) : (
                    <ol className="list-decimal list-inside text-gray-600">
                      {faq.answer.map((item, index) => (
                        <li key={index} className="text-base leading-7">
                          {item}
                        </li>
                      ))}
                    </ol>
                  )}
                </div>
              </div>
              <div
                className="w-full h-1 mt-4 sm:mt-6"
                style={{ backgroundColor: "#66BB6A" }}
              />
            </div>
          ))}
        </div>
        <br />
        <Kartice />
      </div>

      <br />
      <br />
      <br />

      {/* Modal za Register */}
      {showModalRegister && (
        <div
          id="modal-overlay"
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg p-4"
          >
            <Register
              showModalRegister={showModalRegister}
              closeModalRegister={closeModalRegister}
            />
          </div>
        </div>
      )}

      <LandingFooter />
    </>
  );
};
export default Public;

//  <main className="isolate">
//         {/* Hero section */}
//         <div className="relative isolate -z-10">
//           <svg
//             className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
//             aria-hidden="true"
//           >
//             <defs>
//               <pattern
//                 id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
//                 width={200}
//                 height={200}
//                 x="50%"
//                 y={-1}
//                 patternUnits="userSpaceOnUse"
//               >
//                 <path d="M.5 200V.5H200" fill="none" />
//               </pattern>
//             </defs>
//             <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
//               <path
//                 d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
//                 strokeWidth={0}
//               />
//             </svg>
//             <rect width="100%" height="100%" strokeWidth={0} fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)" />
//           </svg>
//           <div
//             className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
//             aria-hidden="true"
//           >
//             <div
//               className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
//               style={{
//                 clipPath:
//                   'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
//               }}
//             />
//           </div>
//           <div className="overflow-hidden">
//             <div className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
//               <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
//                 <div className="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
//                   <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
//                     We’re changing the way people connect.
//                   </h1>
//                   <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
//                     Cupidatat minim id magna ipsum sint dolor qui. Sunt sit in quis cupidatat mollit aute velit. Et
//                     labore commodo nulla aliqua proident mollit ullamco exercitation tempor. Sint aliqua anim nulla sunt
//                     mollit id pariatur in voluptate cillum. Eu voluptate tempor esse minim amet fugiat veniam occaecat
//                     aliqua.
//                   </p>
//                 </div>
//                 <div className="mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
//                   <div className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
//                     <div className="relative">
//                       <img
//                         src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
//                         alt=""
//                         className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
//                       />
//                       <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
//                     </div>
//                   </div>
//                   <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
//                     <div className="relative">
//                       <img
//                         src="https://images.unsplash.com/photo-1485217988980-11786ced9454?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
//                         alt=""
//                         className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
//                       />
//                       <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
//                     </div>
//                     <div className="relative">
//                       <img
//                         src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-x=.4&w=396&h=528&q=80"
//                         alt=""
//                         className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
//                       />
//                       <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
//                     </div>
//                   </div>
//                   <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
//                     <div className="relative">
//                       <img
//                         src="https://images.unsplash.com/photo-1670272504528-790c24957dda?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=left&w=400&h=528&q=80"
//                         alt=""
//                         className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
//                       />
//                       <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
//                     </div>
//                     <div className="relative">
//                       <img
//                         src="https://images.unsplash.com/photo-1670272505284-8faba1c31f7d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&h=528&q=80"
//                         alt=""
//                         className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
//                       />
//                       <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Content section */}
//         <div className="mx-auto -mt-12 max-w-7xl px-6 sm:mt-0 lg:px-8 xl:-mt-8">
//           <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our mission</h2>
//             <div className="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
//               <div className="lg:w-full lg:max-w-2xl lg:flex-auto">
//                 <p className="text-xl leading-8 text-gray-600">
//                   Aliquet nec orci mattis amet quisque ullamcorper neque, nibh sem. At arcu, sit dui mi, nibh dui, diam
//                   eget aliquam. Quisque id at vitae feugiat egestas ac. Diam nulla orci at in viverra scelerisque eget.
//                   Eleifend egestas fringilla sapien.
//                 </p>
//                 <div className="mt-10 max-w-xl text-base leading-7 text-gray-700">
//                   <p>
//                     Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus enim. Mattis mauris semper sed
//                     amet vitae sed turpis id. Id dolor praesent donec est. Odio penatibus risus viverra tellus varius
//                     sit neque erat velit. Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus enim.
//                     Mattis mauris semper sed amet vitae sed turpis id.
//                   </p>
//                   <p className="mt-10">
//                     Et vitae blandit facilisi magna lacus commodo. Vitae sapien duis odio id et. Id blandit molestie
//                     auctor fermentum dignissim. Lacus diam tincidunt ac cursus in vel. Mauris varius vulputate et
//                     ultrices hac adipiscing egestas. Iaculis convallis ac tempor et ut. Ac lorem vel integer orci.
//                   </p>
//                 </div>
//               </div>
//               <div className="lg:flex lg:flex-auto lg:justify-center">
//                 <dl className="w-64 space-y-8 xl:w-80">
//                   {stats.map((stat) => (
//                     <div key={stat.label} className="flex flex-col-reverse gap-y-4">
//                       <dt className="text-base leading-7 text-gray-600">{stat.label}</dt>
//                       <dd className="text-5xl font-semibold tracking-tight text-gray-900">{stat.value}</dd>
//                     </div>
//                   ))}
//                 </dl>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Image section */}
//         <div className="mt-32 sm:mt-40 xl:mx-auto xl:max-w-7xl xl:px-8">
//           <img
//             src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80"
//             alt=""
//             className="aspect-[5/2] w-full object-cover xl:rounded-3xl"
//           />
//         </div>

//         {/* Values section */}
//         <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8">
//           <div className="mx-auto max-w-2xl lg:mx-0">
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our values</h2>
//             <p className="mt-6 text-lg leading-8 text-gray-600">
//               Lorem ipsum dolor sit amet consect adipisicing elit. Possimus magnam voluptatum cupiditate veritatis in
//               accusamus quisquam.
//             </p>
//           </div>
//           <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
//             {values.map((value) => (
//               <div key={value.name}>
//                 <dt className="font-semibold text-gray-900">{value.name}</dt>
//                 <dd className="mt-1 text-gray-600">{value.description}</dd>
//               </div>
//             ))}
//           </dl>
//         </div>

//         {/* Logo cloud */}
//         <div className="relative isolate -z-10 mt-32 sm:mt-48">
//           <div className="absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 justify-center overflow-hidden [mask-image:radial-gradient(50%_45%_at_50%_55%,white,transparent)]">
//             <svg className="h-[40rem] w-[80rem] flex-none stroke-gray-200" aria-hidden="true">
//               <defs>
//                 <pattern
//                   id="e9033f3e-f665-41a6-84ef-756f6778e6fe"
//                   width={200}
//                   height={200}
//                   x="50%"
//                   y="50%"
//                   patternUnits="userSpaceOnUse"
//                   patternTransform="translate(-100 0)"
//                 >
//                   <path d="M.5 200V.5H200" fill="none" />
//                 </pattern>
//               </defs>
//               <svg x="50%" y="50%" className="overflow-visible fill-gray-50">
//                 <path d="M-300 0h201v201h-201Z M300 200h201v201h-201Z" strokeWidth={0} />
//               </svg>
//               <rect width="100%" height="100%" strokeWidth={0} fill="url(#e9033f3e-f665-41a6-84ef-756f6778e6fe)" />
//             </svg>
//           </div>
//           <div className="mx-auto max-w-7xl px-6 lg:px-8">
//             <h2 className="text-center text-lg font-semibold leading-8 text-gray-900">
//               Trusted by the world’s most innovative teams
//             </h2>
//             <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
//               <img
//                 className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
//                 src="https://tailwindui.com/img/logos/158x48/transistor-logo-gray-900.svg"
//                 alt="Transistor"
//                 width={158}
//                 height={48}
//               />
//               <img
//                 className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
//                 src="https://tailwindui.com/img/logos/158x48/reform-logo-gray-900.svg"
//                 alt="Reform"
//                 width={158}
//                 height={48}
//               />
//               <img
//                 className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
//                 src="https://tailwindui.com/img/logos/158x48/tuple-logo-gray-900.svg"
//                 alt="Tuple"
//                 width={158}
//                 height={48}
//               />
//               <img
//                 className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
//                 src="https://tailwindui.com/img/logos/158x48/savvycal-logo-gray-900.svg"
//                 alt="SavvyCal"
//                 width={158}
//                 height={48}
//               />
//               <img
//                 className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
//                 src="https://tailwindui.com/img/logos/158x48/statamic-logo-gray-900.svg"
//                 alt="Statamic"
//                 width={158}
//                 height={48}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Team section */}
//         <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-48 lg:px-8">
//           <div className="mx-auto max-w-2xl lg:mx-0">
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our team</h2>
//             <p className="mt-6 text-lg leading-8 text-gray-600">
//               Sit facilis neque ab nulla vel. Cum eos in laudantium. Temporibus eos totam in dolorum. Nemo vel facere
//               repellendus ut eos dolores similique.
//             </p>
//           </div>
//           <ul
//             role="list"
//             className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6"
//           >
//             {team.map((person) => (
//               <li key={person.name}>
//                 <img className="mx-auto h-24 w-24 rounded-full" src={person.imageUrl} alt="" />
//                 <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">{person.name}</h3>
//                 <p className="text-sm leading-6 text-gray-600">{person.role}</p>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Blog section */}
//         <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8">
//           <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">From the blog</h2>
//             <p className="mt-2 text-lg leading-8 text-gray-600">
//               Vel dolorem qui facilis soluta sint aspernatur totam cumque.
//             </p>
//           </div>
//           <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
//             {blogPosts.map((post) => (
//               <article
//                 key={post.id}
//                 className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
//               >
//                 <img src={post.imageUrl} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover" />
//                 <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
//                 <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

//                 <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm leading-6 text-gray-300">
//                   <time dateTime={post.datetime} className="mr-8">
//                     {post.date}
//                   </time>
//                   <div className="-ml-4 flex items-center gap-x-4">
//                     <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
//                       <circle cx={1} cy={1} r={1} />
//                     </svg>
//                     <div className="flex gap-x-2.5">
//                       <img src={post.author.imageUrl} alt="" className="h-6 w-6 flex-none rounded-full bg-white/10" />
//                       {post.author.name}
//                     </div>
//                   </div>
//                 </div>
//                 <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
//                   <a href={post.href}>
//                     <span className="absolute inset-0" />
//                     {post.title}
//                   </a>
//                 </h3>
//               </article>
//             ))}
//           </div>
//         </div>
//       </main>
